"use strict";

import {gh} from '../../general/general-helpers';

(function( $ ) {
	// Only for Home page
	if ( $( 'body' ).hasClass( 'page-template-page-home-new' ) ) {

		/* Big Quote
		-------------------------------------------------------------------*/
		// set position of decoration line
		function positionBigQuoteDecorLine() {
			document.querySelectorAll( '.big-quote__bg' ).forEach( ( elem ) => {
				elem.style.left = Math.floor(parseInt(elem.style.left)) - elem.getBoundingClientRect().left -0.5 + 'px';
			} );
		}

		gh.doOnEvent( {
			start:             null,
			resize:            100,
			orientationchange: null, // on window orientationchange (for older browsers)
		}, positionBigQuoteDecorLine );


		/* Load More functionality
		-------------------------------------------------------------------*/
		const loadMoreBtn = document.getElementById( 'load-more-btn' );

		loadMoreBtn.addEventListener( 'click', function() {

			gh.simpleLoadMoreContent(
				{
					action:       'home_load_more_content',
					loaded_posts: yeHomeLoadedPosts, // set in page-home-new.php
					home_id:      yeHomeLoadedPosts.homePageID,
				},
				this,
				false,
				() => {
					positionBigQuoteDecorLine();
				},
			);
		} ); // CLICK
		
		/* Click on the title (markovka) of Populars slider rotates it to the next slide
		-------------------------------------------------------------------*/
		document.querySelector( '.home-ps-nav-title' ).firstElementChild.addEventListener( 'click', () => {
			document.querySelector( '.popular-posts-slider .owl-nav' ).lastElementChild.click();
		} );


		/* Special projects (sobytia) slider
		-------------------------------------------------------------------*/
		$('.spec-p-slider').owlCarousel( {
			margin:     0,
			dots:       true,
			nav:        false,
			loop:       false,
			autoHeight: true,
			items:      1,
			// navContainerClass: 'owl-nav',
			smartSpeed: 500,
		} );

	} // IF this page
})( jQuery );

